<template>
    <div class="land-more-info-section">
        <div class="container" v-if="salesCard.more_info_title != ''">
            <div class="land-section-title" v-if="projectNameG != 'duman'">
                <h3 v-html="salesCard.more_info_title"></h3>
            </div>
        </div>
        <div class="land-more-info-cards">
            <div class="card-item" v-for="item in salesCard.more_info_cards">
                <div class="section-title-mobile" v-if="isMobileChecker">
                    <div class="pic-title-bg" :style="'background-image: url(' + item.section_title_img + ')'"></div>
                    <h2 v-html="item.title"></h2>
                </div>
                <div class="container">
                    <div class="land-card-column-container">
                        <div class="col-left">
                            <div class="section-title" v-if="!isMobileChecker">
                                <h2 v-html="item.title"></h2>
                            </div>
                            <div class="desc-html" v-html="item.desc"></div>
                            <div class="desc-icons-list list-six" v-if="item.icon_list.length > 0" :class="'desc-icons-' + projectNameG">
                                <ul>
                                    <li v-for="(item, index) in item.icon_list" :key="index">
                                        <div class="icon-img">
                                            <img :src="item.icon" alt="">
                                        </div>
                                        <!-- <div class="item-num" v-if="projectNameG == 'duman' && isMobileChecker">{{ index + 1 }}</div> -->
                                        <div class="icon-desc">
                                            <p v-html="item.desc"></p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-right" v-if="!isMobileChecker">
                            <div class="col-img">
                                <img :src="item.img" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'sale-land-more-info',
        components: {
        },
        data () {
            return {
                projectNameG: window.host,
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/land-more-info.scss';
    @import '@/styles/components/sales/respond/land-more-info-respond.scss';
</style>